import axios from '@/jslib/axios'

export const getAdjustEditResult = data => {
  return axios({
    method: 'post',
    url: '/admin/adjust/edit/result',
    data
  })
}
export const getAdjustQuoteResult = data => {
  return axios({
    method: 'post',
    url: 'admin/adjust/quote/result',
    data
  })
}
export const getQuoteMain = data => {
  return axios({
    method: 'post',
    url: '/admin/quote/main',
    data
  })
}

//分析編輯改單結果--begin endorsement 改单下一步
export const getEndorsementQuoteResult = data => {
  return axios({
    method: 'post',
    url: '/admin/endorsement/quote/result',
    data
  })
}

export const saveEndorsementQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/endorsement/quote/save',
    data
  })
}

export const editEndorsementQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/endorsement/quote/edit',
    data
  })
}

export const deliverEndorsement = data => {
  return axios({
    method: 'post',
    url: '/admin/endorsement/deliver',
    data
  })
}

export const changeEndorsementStatus = data => {
  return axios({
    method: 'put',
    url: '/admin/endorsement/change/status',
    data
  })
}

export const getEndorsementQuoteView = params => {
  return axios({
    method: 'get',
    url: '/admin/endorsement/view',
    params
  })
}

export const undoEndorsement = data => {
  return axios({
    method: 'post',
    url: '/admin/endorsement/undo',
    data
  })
}

export const sendEndorsementInsurer = data => {
  return axios({
    method: 'post',
    url: '/admin/endorsement/send/insurer',
    data
  })
}

export const getCancelQuoteResult = data => {
  return axios({
    method: 'post',
    url: '/admin/cancel/quote/result',
    data
  })
}

export const saveCancelQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/cancel/quote/save',
    data
  })
}

export const saveAdjustEdit = data => {
  return axios({
    method: 'post',
    url: '/admin/adjust/edit/save',
    data
  })
}
